/* eslint-disable import/first */
import React, { Component } from "react";
import { Formik } from "formik";
import { Route, withRouter } from "react-router-dom";
import {
	Navbar,
	Nav,
	NavDropdown,
	Form,
	Button,
	Row,
	Col,
	Jumbotron,
	Table,
	Tr,
	Td,
	Pagination,
} from "react-bootstrap";
import { NavAdmin } from "components/nav/NavAdmin";
import * as config from "config/config";
import DatePickerField from "helpers/datePickerField";
const dateFormatConvert = require("helpers/dateFormatConvert");

/*CSS*/
import "../../../../asset/css/add.css";

class AddTournee extends Component {
	constructor() {
		super();
		this.state = {
			etat: [],
			livreurs: [],
			formikInit: { date: "", zone: "", etat: "", livreur: "" },
		};
	}
	componentDidMount() {
		config
			.apiFetch(config.Api_Url + "/tournee/getEtat/")
			.then((response) => response.json())
			.then((data) => {
				let etat = [];
				for (let number = 0; number < data["data"].length; number++) {
					switch (data["data"][number]["etat"]) {
						case "30":
							etat.push(
								<option defaultValue key={"option_etat_" + number} value="0">
									Non terminée
								</option>
							);
							break;
						case "32":
							etat.push(
								<option key={"option_serviceCode_" + number} value="2">
									Terminée
								</option>
							);
							break;
					}
				}
				this.setState({
					etat: [etat],
				});
			});
		config
			.apiFetch(config.Api_Url + "/livreurs")
			.then((response) => response.json())
			.then((data) => {
				let livreurs = [];

				for (let number = 0; number < data["data"].length; number++) {
					livreurs.push(
						<option
							key={"option_livreurs_" + number}
							value={data["data"][number]["livreur_id"]}
						>
							{data["data"][number]["nom"] + " "}{" "}
							{data["data"][number]["prenom"]}
						</option>
					);
				}
				this.setState({
					livreurs: [livreurs],
					formikInit: {
						date: "",
						zone: "",
						etat: "0",
						livreur: data["data"][0]["livreur_id"],
					},
				});
			});
	}
	render() {
		return (
			<div>
				<NavAdmin />
				<div className="container">
					<Row className="justify-content-center">
						<Col md={6}>
							<h1>Ajouter une tournée</h1>
							<Formik
								enableReinitialize={true}
								initialValues={this.state.formikInit}
								onSubmit={(values, { setSubmitting }) => {
									config
										.apiFetch(config.Api_Url + "/new/tournee", {
											method: "POST",
											body: JSON.stringify({
												date: dateFormatConvert.convertDateForSql(values.date),
												zone: values.zone,
												etat: values.etat,
												livreur: values.livreur,
											}),
											headers: {
												"Content-Type": "application/json",
											},
										})
										.then((response) => response.json())
										.then((data) => {
											this.props.history.push(
												"/admin/tournee/addcolistotournee/" +
													data.data.insertId +
													"/0/0/0"
											);
										});
								}}
							>
								{({
									values,
									errors,
									touched,
									handleChange,
									handleBlur,
									handleSubmit,
									isSubmitting,
									/* and other goodies */
								}) => (
									<Form onSubmit={handleSubmit} autoComplete="off">
										<div className="required mt-4">Date Tournée :</div>
										<DatePickerField
											name="date"
											required
											className="form-control"
										/>
										<div>
											<Form.Label>Zone :</Form.Label>
											<Form.Control
												type="text"
												aria-describedby="inputGroupPrepend"
												name="zone"
												value={values.zone}
												onChange={handleChange}
											/>

											<Form.Label className="required">Etat :</Form.Label>
											<Form.Control
												required
												as="select"
												name="etat"
												value={values.etat}
												onChange={handleChange}
											>
												{this.state.etat}
											</Form.Control>
											<Form.Label className="required">Livreur :</Form.Label>
											<Form.Control
												required
												as="select"
												name="livreur"
												value={values.livreur}
												onChange={handleChange}
											>
												{this.state.livreurs}
											</Form.Control>
										</div>
										<Button
											size="sm"
											className="mt-3"
											type="submit"
											disabled={isSubmitting}
										>
											Enregistrer
										</Button>
									</Form>
								)}
							</Formik>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default withRouter(AddTournee);
